<template>
    <div v-bind:class="'modal-header bg-'+color">        
        <h5> {{ title }}</h5>
        <button type="button" v-if="btnClose" class="close" v-on:click="handleClose" >
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    
</template>
<script lang="ts" setup>
  defineProps<{
    color: string,
    title: string,
   btnClose:boolean
  }>();

   const emit = defineEmits<{
        (e: 'operationCloseModal'): void
    }>();
    
    const handleClose = () => emit('operationCloseModal');

</script>